import {
  componentNameConstants,
  dlElementConstants,
  dlEventConstants,
} from "@repo/analytics/data-layer.constants";
import { dataLayer } from "@repo/analytics/data-layer-utils";

type StockFilterCtOptions = {
  event: string;
  element: string;
  sectionTitle: string;
  filterCategory?: string;
  filterSubCategory?: string;
  search?: string;
  epSection?: string;
  epSubText?: string;
  epCta?: string;
};

export function pushStockFilterCtEvent({
  event,
  element,
  sectionTitle,
  filterCategory = "NA",
  filterSubCategory = "NA",
  search = "NA",
  epSection,
  epSubText,
  epCta,
}: StockFilterCtOptions) {
  dataLayer(
    "",
    {
      component: componentNameConstants.STOCKS_FILTER,
      event,
      element,
      section_title: sectionTitle,
      cta_text: sectionTitle,
    },
    {
      EVENT_NAME: dlElementConstants.PLP_CLICKED,
      EP_PAGE_NAME: "DEMAT PLP",
      EP_JOURNEY_NAME: dlElementConstants.TRADING_MALL_STOCK_PLP,
      EP_FILTER_CATEGORY: filterCategory,
      EP_FILTER_SUB_CATEGORY: filterSubCategory,
      EP_SEARCH: search,
      EP_SECTION: epSection ?? "NA",
      EP_SUB_TEXT: epSubText ?? "NA",
      EP_CTA: epCta ?? "NA",
      ET_CTA: sectionTitle,
    },
  );
}

export function mapFilterTabCtaLabel(categoryKey: string): string {
  switch (categoryKey) {
    case "alphabetical":
      return "Alphabetical order";
    case "exchange":
      return "Index";
    case "sector":
      return "Sector";
    case "mktCapType":
      return "Market cap";
    default:
      return "NA";
  }
}

export const stockFilterCtConstants = {
  checkboxClick: dlEventConstants.CHECKBOX_CLICK,
  tabClick: dlEventConstants.TAB_CLICK,
  iconClick: dlEventConstants.ICON_CLICK,
  buttonClick: dlEventConstants.BUTTON_CLICK,
  checkboxElement: dlElementConstants.STOCKS_FILTER_CHECKBOX_CLICK,
  tabElement: dlElementConstants.STOCKS_FILTER_TAB_CLICK,
};
